/**
 * Custom: hide Promotion banners with data-portal-id, clone them into matching grid slots.
 */
(function () {
  if (window.Shopify && Shopify.designMode) return;

  function portal() {
    document.querySelectorAll('[data-portal-id]').forEach(function (el) {
      if (!el.closest('[data-promo-portal-slot]')) {
        (el.closest('[id^="shopify-section-"]') || el).hidden = true;
      }
    });

    document.querySelectorAll('[data-promo-portal-slot]').forEach(function (slot, i) {
      var id = slot.dataset.portalId;
      var reserve = slot.querySelector('.collection-promo-portal__reserve');
      var source = id && [].find.call(document.querySelectorAll(`[data-portal-id="${id}"]`), function (el) {
        return !el.closest('[data-promo-portal-slot]');
      });

      slot.innerHTML = '';
      if (reserve) slot.appendChild(reserve);
      slot.classList.toggle('is-empty', !source);
      slot.classList.toggle('is-portaled', !!source);
      if (!source) return;

      var clone = (source.closest('[id^="shopify-section-"]') || source).cloneNode(true);
      clone.hidden = false;
      if (clone.id) clone.id += `-portal-${i}`;
      slot.appendChild(clone);
    });
  }

  function ready() {
    portal();
    document.addEventListener('collection:rerendered', portal);
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ready) : ready();
})();
